import React from 'react';
import { Link, Typography } from '@mui/material';

interface phoneNumber {
  heading?: string;
  number: string | number;
}
export const Phone: React.FC<phoneNumber> = ({ number, heading }) => {
  const style = {
    color: '#0A3551',
    fontSize: '18px',
    fontWeight: '700',
    textTransform: 'uppercase',
    lineHeight: '22px',
    textAlign: 'right',
    textDecorationLine: 'underline',
  };

  return (
    <Typography sx={{ ...style }}>{number}</Typography>
    // <Link
    //   sx={style}
    //   variant="subtitle1"
    //   href={`tel:${number}`}
    //   underline="none"
    // >
    //   {number}
    // </Link>
  );
};
